import { RootState } from "../../../infrastructure/state/store";

export const isAnyCollectionBusySelector = (state: RootState) => state.activityHistoryCollections.busy.length > 0;

export const isSomeCollectionLoadedAndOtherLoading = (state: RootState) => {
  const collections = Object.values(state.activityHistoryCollections.collections);
  return collections && isAnyCollectionBusySelector(state);
};

export const isEmptyDataAndOtherLoading = (state: RootState) => {
  const collections = Object.values(state.activityHistoryCollections.collections);
  return !collections?.length && isAnyCollectionBusySelector(state);
};
